import "./App.css";

import Navbar from "./components/Navbar";
import FloatingSidebar from "./components/FloatingSidebar";
import Footer from "./components/Footer";

import Cadenly from "./components/Calendly";
import Benefits from "./components/Benefits";
import ZbrushDistributor from "./components/ZbrushDistributor";
import Financing from "./components/Financing";
import FAQ from "./components/FAQ";

function App() {

    return (
        <div className="App">
            <Navbar />
            <FloatingSidebar />
            <Cadenly/>
            <Benefits />
            <ZbrushDistributor />
            <Financing />
            <FAQ />
            <Footer />
        </div>
    );
}

export default App;
